<template>
    <div class="box">
        <h4>{{ title }}</h4>
        <ul class="categories">
            <li v-for="category in categories"
                :key="category.id"
            >
                <a :href="category.slug">
                    {{ category.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'

export default defineComponent({

    props: [
        'mainCategory',
        'categories',
        'title'
    ],
})
</script>
